import { APIService } from "@/config/api-service-client.js";

const PATH = (activeEntityID) => `/atu-entity/${activeEntityID}/mail/templates`;

const getDefaultState = () => {
  return {};
};

export default {
  state: getDefaultState(),
  mutations: {},
  actions: {
    async fetchEmailTemplates(ctx) {
      const with_projections = true;
      const entityID = ctx.getters.getActiveEntity.id;
      let route = PATH(entityID);
      if (with_projections) {
        route = `${route}?with_projections=true`;
      }
      try {
        const resp = await APIService.get(route);
        return resp;
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async fetchEmailTemplateByType(ctx, type) {
      const entityID = ctx.getters.getActiveEntity.id;
      try {
        const resp = await APIService.get(`${PATH(entityID)}/${type}`);
        return resp;
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async resetEmailTemplateByType(ctx, type) {
      const entityID = ctx.getters.getActiveEntity.id;
      try {
        const resp = await APIService.delete(`${PATH(entityID)}/${type}`);
        return resp;
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async editEmailTemplateByType(ctx, { type, data }) {
      const entityID = ctx.getters.getActiveEntity.id;
      try {
        const resp = await APIService.put(`${PATH(entityID)}/${type}`, data);
        return resp;
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async fetchEmailTemplateTags(_, type) {
      try {
        const resp = await APIService.get(`/mail/templates/${type}/tags`);
        return resp;
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
  },
  getters: {},
};
